import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { ErrorCode, getUserErrorMessage } from "./errorMessages";

export class AppError extends Error {
  constructor(message, code, meta, severity, recoverable = true, silent = false) {
    super(message);
    this.code = code;
    this.meta = meta;
    this.severity = severity;
    this.recoverable = recoverable;
    this.silent = silent;

    if (!message) {
      this.message = getUserErrorMessage(this.code);
    }
  }
}

export class SpeechTokenError extends AppError {
  constructor(meta, message) {
    super(message, ErrorCode.SPEECH_TOKEN_ERROR, meta, SeverityLevel.Critical, false);
  }
}

export class TranscriptionError extends AppError {
  constructor(meta, message) {
    super(message, ErrorCode.TRANSCRIPTION_ERROR, meta, SeverityLevel.Error, true);
  }
}

export class TranslationError extends AppError {
  constructor(meta, message) {
    super(message, ErrorCode.TRANSLATION_ERROR, meta, SeverityLevel.Error, true);
  }
}

export class FeedbackError extends AppError {
  constructor(meta, message) {
    super(message, ErrorCode.FEEDBACK_ERROR, meta, SeverityLevel.Error, true);
  }
}
export class MicrophoneBlockedError extends AppError {
  constructor(meta, message) {
    super(message, ErrorCode.MICROPHONE_BLOCKED_ERROR, meta, SeverityLevel.Critical, false);
  }
}

export class SessionError extends AppError {
  constructor(meta, message) {
    super(message, ErrorCode.SESSION_ERROR, meta, SeverityLevel.Error, false, true);
  }
}

export class ReportError extends AppError {
  constructor(meta, message) {
    super(message, ErrorCode.REPORT_ERROR, meta, SeverityLevel.Error, true);
  }
}
